// src/components/exercises/exerciseDetection.js

export const calculateAngle = (a, b, c) => {
  const radians = Math.atan2(c.y - b.y, c.x - b.x) - Math.atan2(a.y - b.y, a.x - b.x);
  let angle = Math.abs(radians * 180.0 / Math.PI);
  if (angle > 180.0) angle = 360 - angle;
  return angle;
};

export const detectSquats = ({
  landmarks, hasGoneDown, squatStartTime, standingKneeAngle,
  maxSquatDepth, language, onRepComplete, setStatus
}) => {
  const leftHip = landmarks[23], leftKnee = landmarks[25], leftAnkle = landmarks[27];
  const rightHip = landmarks[24], rightKnee = landmarks[26], rightAnkle = landmarks[28];

  if (![leftHip, leftKnee, leftAnkle, rightHip, rightKnee, rightAnkle]
    .every(p => p && p.visibility > 0.5)) {
    setStatus(language === 'mr' ? 'पूर्ण शरीर दाखवा' : 'Show your full body');
    return;
  }

  const leftKneeAngle = calculateAngle(leftHip, leftKnee, leftAnkle);
  const rightKneeAngle = calculateAngle(rightHip, rightKnee, rightAnkle);
  const bothBent = leftKneeAngle < 100 && rightKneeAngle < 100;
  const bothStraight = leftKneeAngle > 160 && rightKneeAngle > 160;
  const avgHipY = (leftHip.y + rightHip.y) / 2;
  const avgKneeY = (leftKnee.y + rightKnee.y) / 2;
  const hipsBelowKnees = avgHipY > avgKneeY;

  if (bothStraight && !hasGoneDown.current) {
    standingKneeAngle.current = Math.min(leftKneeAngle, rightKneeAngle);
    maxSquatDepth.current = null;
  }

  if (bothBent && hipsBelowKnees && !hasGoneDown.current) {
    if (!squatStartTime.current) {
      squatStartTime.current = Date.now();
      setStatus(language === 'mr' ? 'खाली जा... position धर!' : 'Going down... Hold!');
      return;
    }
    const depth = Math.min(leftKneeAngle, rightKneeAngle);
    if (!maxSquatDepth.current || depth < maxSquatDepth.current) {
      maxSquatDepth.current = depth;
    }
    if (Date.now() - squatStartTime.current >= 200) {
      hasGoneDown.current = true;
      setStatus(language === 'mr' ? 'उत्तम! आता उभा राहा!' : 'Perfect! Stand up!');
    }
  } else if (bothStraight && hasGoneDown.current) {
    if (standingKneeAngle.current && maxSquatDepth.current) {
      const range = standingKneeAngle.current - maxSquatDepth.current;
      if (range < 70) {
        hasGoneDown.current = false;
        squatStartTime.current = null;
        setStatus(language === 'mr' ? 'अधिक खाली जा!' : 'Go deeper!');
        return;
      }
    }
    hasGoneDown.current = false;
    squatStartTime.current = null;
    onRepComplete();
  } else if (!bothBent && squatStartTime.current && !hasGoneDown.current) {
    squatStartTime.current = null;
    setStatus(language === 'mr' ? 'अधिक खाली जा!' : 'Squat deeper!');
  }
};

export const detectJumpingJacks = ({
  landmarks, armsUp, legsApart, hasCompletedJump, jumpStartTime,
  language, onRepComplete, setStatus
}) => {
  const leftShoulder = landmarks[11], rightShoulder = landmarks[12];
  const leftWrist = landmarks[15], rightWrist = landmarks[16];
  const leftAnkle = landmarks[27], rightAnkle = landmarks[28];

  if (![leftShoulder, rightShoulder, leftWrist, rightWrist, leftAnkle, rightAnkle]
    .every(p => p && p.visibility > 0.5)) {
    setStatus(language === 'mr' ? 'पूर्ण शरीर दाखवा' : 'Show your full body');
    return;
  }

  const currentArmsUp = leftWrist.y < leftShoulder.y - 0.05 &&
    rightWrist.y < rightShoulder.y - 0.05;
  const ankleDistance = Math.abs(leftAnkle.x - rightAnkle.x);
  const shoulderDistance = Math.abs(leftShoulder.x - rightShoulder.x);
  const currentLegsApart = ankleDistance > shoulderDistance * 1.5;
  const inJumpPosition = currentArmsUp && currentLegsApart;

  if (inJumpPosition && !hasCompletedJump.current) {
    if (!jumpStartTime.current) {
      jumpStartTime.current = Date.now();
      return;
    }
    if (Date.now() - jumpStartTime.current >= 50) {
      armsUp.current = true;
      legsApart.current = true;
      setStatus(language === 'mr' ? 'उत्तम! आता परत या!' : 'Perfect! Jump back!');
    }
  } else if (!currentArmsUp && !currentLegsApart && armsUp.current && legsApart.current) {
    hasCompletedJump.current = true;
    armsUp.current = false;
    legsApart.current = false;
    jumpStartTime.current = null;
    onRepComplete();
    setTimeout(() => { hasCompletedJump.current = false; }, 150);
  } else if (!inJumpPosition && jumpStartTime.current && !armsUp.current) {
    jumpStartTime.current = null;
    setStatus(language === 'mr' ? 'हात वर आणि पाय दूर!' : 'Arms up and legs wide!');
  }
};